<template>
    <div class="ui-expaliner" :class="rootClass" ref="ui-expaliner" :style="uiExplainerStyle">
        <flow-container
            v-if="isFlex"
            :children="tpl.children"
            :isPurePreview="isPreview"
            :class="flexClass"
            :style="flexStyle"
            class="ui-expaliner-flex"
        ></flow-container>
        <free-container
            v-else
            :children="tpl.children"
            :isPurePreview="isPreview"
            class="ui-expaliner-absolute"
        ></free-container>
    </div>
</template>

<script>
const {
    plugins: { ComplexComp },
    store: { cmp }
} = require('@futuweb/fego-render');
const {
    rem: { parseStyle }
} = require('@futuweb/fego-bridge');

export default {
    props: ['tpl'],
    components: {
        FlowContainer: ComplexComp.Container.Flow,
        FreeContainer: ComplexComp.Container.Free
    },
    computed: {
        rootClass() {
            const r = [];
            const { autoWidth, autoHeight } = this.tpl.props || {};

            if (autoWidth) {
                r.push(' auto-width');
            }

            if (autoHeight) {
                r.push('auto-height');
            }

            return r;
        },
        isPreview() {
            // 判断是否预览模式
            return this.$parent.isPurePreview || this.$parent.isPureRenderer;
        },
        isFlex() {
            return this.tpl.props.layout === 'flex';
        },
        flexStyle() {
            const { justifyContent, alignItems } = this.tpl.props;
            return {
                justifyContent,
                alignItems
            };
        },
        flexClass() {
            const { flexDirection } = this.tpl.props;
            return ['flex-direction-' + flexDirection];
        },
        uiExplainerStyle() {
            const { style } = this.tpl;
            const { flexDirection, justifyContent, alignItems } = this;
            let r = Object.assign({ position: 'relative' }, style);
            r = Object.assign(r, this.styleFromParent);
            if (this.isFlex) {
                r = Object.assign(r, {
                    flexDirection,
                    justifyContent,
                    alignItems
                });
            }
            const styleObject = parseStyle(r);
            if (cmp.getVmById(this.tpl.id) === cmp.root) {
                styleObject.margin = '0 auto';
            }
            return styleObject;
        }
    }
};
</script>
<style lang="less" scoped>
.ui-expaliner.auto-height {
    height: auto !important;
    > .ui-expaliner-absolute > *:first-child {
        position: relative !important;
        top: 0 !important;
    }
}

.ui-expaliner.auto-width {
    width: auto !important;
    > .ui-expaliner-absolute > *:first-child {
        position: relative !important;
        left: 0 !important;
    }
}

.ui-expaliner > .ui-expaliner-flex.flex-direction-column {
    flex-direction: column !important;
}

.ui-expaliner > .ui-expaliner-flex.flex-direction-row {
    flex-direction: row !important;
}
</style>
